import script from "./freone.vue?vue&type=script&setup=true&lang=js"
export * from "./freone.vue?vue&type=script&setup=true&lang=js"

import "./freone.vue?vue&type=style&index=0&id=b1e75758&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1e75758"]])

export default __exports__